module.exports = __webpack_public_path__ + "img/png03.d5c7690d.png";